import Vue from 'vue'
import moment from 'moment'

import VueMoment from 'vue-moment'
Vue.use(VueMoment,{moment})
moment.locale('nl')

console.log('moment....')